import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-top: 0.4rem;
`
export const Title = styled.h1`
  align-self: flex-start;
`
